import { render, staticRenderFns } from "./ConfirmationLinkExpired.vue?vue&type=template&id=64e0f854"
import script from "./ConfirmationLinkExpired.vue?vue&type=script&lang=js"
export * from "./ConfirmationLinkExpired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports